export const enum PageManagementModules {
  HOABL_HOME = "5001",
  INVESTMENTS = "5002",
  PROMISES = "5003",
  PORTFOLIO = "5004",
  PROFILE = "5005",
  FOOTER_TABS = "5006",
}
